import React, { createContext, useContext, useRef, useCallback } from "react";

const ChatCommandContext = createContext(null);

export function ChatCommandProvider({ children }) {
	const listenersRef = useRef([]);

	const subscribe = useCallback((fn) => {
		listenersRef.current.push(fn);
		return () => {
			listenersRef.current = listenersRef.current.filter(l => l !== fn);
		};
	}, []);

	const dispatch = useCallback((cmd) => {
		listenersRef.current.forEach(fn => fn(cmd));
	}, []);

	return (
		<ChatCommandContext.Provider value={{ subscribe, dispatch }}>
			{children}
		</ChatCommandContext.Provider>
	);
}

export function useChatCommand(handler) {
	const ctx = useContext(ChatCommandContext);
	React.useEffect(() => {
		if (!ctx || !handler) return;
		return ctx.subscribe(handler);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
}

export function useChatCommandDispatch() {
	const ctx = useContext(ChatCommandContext);
	return ctx?.dispatch ?? (() => {});
}
